import { render, staticRenderFns } from "./city-child-add.vue?vue&type=template&id=55aedb0a&scoped=true&"
import script from "./city-child-add.vue?vue&type=script&lang=js&"
export * from "./city-child-add.vue?vue&type=script&lang=js&"
import style0 from "./city-child-add.vue?vue&type=style&index=0&id=55aedb0a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55aedb0a",
  null
  
)

export default component.exports